export default "__VITE_ASSET__BBBXSCuS__"